import React, { useRef, PropsWithChildren } from 'react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

export const QueryProvider = ({ children }: PropsWithChildren) => {
  const client = useRef(
    new QueryClient({
      defaultOptions: {
        queries: {
          retry: 0,
        }
      }
    })
  ).current
  return <QueryClientProvider client={client}>{children}</QueryClientProvider>
};
